import { cn } from '~/styles/extended-theme';

import { RichTextHtmlViewer } from '../rich-text/rich-text-html-viewer';

interface WaiverModalContentProps {
  waiverHtml: string;
  className?: string;
}

export function WaiverModalContent({
  waiverHtml,
  children,
  className,
}: React.PropsWithChildren<WaiverModalContentProps>) {
  return (
    <div className={cn('mt-6 rounded border border-black', className)}>
      <div className="max-h-[305px] overflow-y-scroll pr-2 text-body2">
        <RichTextHtmlViewer rawHtml={waiverHtml} />
        {children}
      </div>
    </div>
  );
}
